import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {SASEUNG3_BOOKMARK_API_URL} from '../../defines/protocol';
import {Saseung3HanjaService} from '../saseung3-hanja/saseung3-hanja.service';
import {ApiService} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class Saseung3BookmarkService extends Saseung3HanjaService {
  constructor(
    protected override api: ApiService,
  ) {
    super(api);
    this.urlApi = SASEUNG3_BOOKMARK_API_URL;
  }

  public sendBookmark(id: string, add: boolean = true): Observable<any> {
    const url = this.urlApi + id + '/';
    const obs = add ?
      this.api.Post(url, null) :
      this.api.Delete(url);

    return obs.pipe(
      map(data => {
        console.log('Saseung3BookmarkService::sendBookmark', id, add, data);
        return data;
      }),
    );
  }
}
